/*
 * @Descripttion: 
 * @version: 
 * @Author: Terry
 * @Date: 2020-06-04 17:18:56
 * @LastEditors: Terry
 * @LastEditTime: 2021-09-20 16:47:44
 */ 
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes:[
    //登录
    {name: "login",path: "/login",component: ()=>import("@/views/platform/auth//Login.vue")},
    //项目选择
    {name: "prjList",path: "/list",component: ()=>import("@/views/platform/project/Index.vue")},
     // 人员管理
    {name: 'certification',path: 'certification',component: ()=>import("@/views/BI/certification/Index.vue")},
  ]
});

// module.exports =  router;
